import { useRouter } from 'next/router';

export default function usePrefix(): string {
  const router = useRouter();
  return router.pathname?.indexOf('myapp') != -1 ? '/myapp' : '';
}
